import { useGetClaimStatusProperty } from 'hooks/utils.hook';
import Typography from 'styles/typography/Typograpy';
import { IClaim } from 'types/Claim';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ClaimStatusBreadcrumbs = ({ claim }: { claim: IClaim }) => {
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const { getClaimStatus } = useGetClaimStatusProperty();

	const {
		status: { id },
	} = claim;

	const errorIds = [2, 7, 8, 15];

	return (
		<Typography variant="bodyLink" color={errorIds.includes(id) ? 'error' : ''}>
			{tDbLabels(getClaimStatus(id)?.label)}{' '}
			{claim.status.reasonCodeLabel && id !== 14 && (
				<Typography variant="body">
					{tClientLabels('claim.labels.reasonCode', {
						reasonCode: tDbLabels(claim.status.reasonCodeLabel || ''),
					})}
				</Typography>
			)}
		</Typography>
	);
};

export default ClaimStatusBreadcrumbs;
